import styled from 'styled-components';
import { colors } from '../../globalStyles';

export const Box = styled.div((props: { swipeable?: boolean; }) => ({
  backgroundColor: colors.white,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${colors.border}`,
  borderRadius: '5px',
  padding: '5px 20px 10px 20px',
  margin: '10px 10px',
  '@media only screen and (min-width: 600px)': {
    margin: props.swipeable ? '10px 50px' : 0,
  },
}));

export const BoxName = styled.h2({
  paddingTop: '20px',
  fontSize: '26px',
  fontWeight: 500,
  textAlign: 'center',
});

export const BoxTitle = styled.div({
  textAlign: 'center',
  color: colors.green,
  fontSize: '18px',
  marginBottom: '20px',
});

export const BoxDivider = styled.hr({
  height: '3px',
  color: colors.green,
  backgroundColor: colors.green,
  border: 'none',
  width: '60%',
  marginTop: '0px',
});

export const BoxTitleSmall = styled.small({
  color: colors.green,
  fontWeight: 500,
  fontSize: '12px',
});

export const BoxWarning = styled.div({
  textAlign: 'center',
  marginTop: '15px',
  fontStyle: 'italic',
});

export const BoxInfo = styled.div({
  display: 'block',
  borderRadius: '5px',
  padding: '20px',
  width: '80%',
  height: '100%',
  minHeight: '150px',
  boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
  '@media only screen and (max-width: 944px)': {
    margin: '0 auto',
    width: '100%',
  },
  backgroundColor: colors.white,
});

export const BoxInfoTitle = styled.p((props: { active?: boolean; }) => ({
  fontWeight: 'bold',
  '@media only screen and (max-width: 660px)': {
    fontSize: '17px',
  },
  color: props.active ? colors.green : colors.red,
}));
